import React from 'react';

import { useEmployersTableListQuery } from 'src/api';
import { ModalId } from 'src/constants/modals';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import {
  prepareEmployerSearchFilterByCategories,
  prepareEmployersFilterByStatus,
} from 'src/utils/employer';

import { EmployerInnerTableClearVerifyStaff } from './EmployerInnerTableClearVerifyStaff';

export const EmployersTableClearVerifyStaff: React.FC = () => {
  const searchQueryVariables = useSearchQueryVariables(prepareEmployerSearchFilterByCategories);
  const { filter, sortQueryVariable, paginationQueryVariables, pagination } = useFilterStorage();

  const {
    data: employers,
    previousData,
    loading,
    refetch,
  } = useEmployersTableListQuery({
    variables: {
      filter: {
        ...searchQueryVariables,
        ...prepareEmployersFilterByStatus(filter),
      },
      ...paginationQueryVariables,
      orderBy: sortQueryVariable,
    },
    notifyOnNetworkStatusChange: true,
  });

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  const employersList = React.useMemo(() => {
    return (loading ? previousData?.employerList : employers?.employerList) || [];
  }, [loading, previousData?.employerList, employers?.employerList]);

  const employersCount = React.useMemo(() => {
    return (loading ? previousData?.employerCount : employers?.employerCount) || 0;
  }, [loading, previousData?.employerCount, employers?.employerCount]);

  return (
    <EmployerInnerTableClearVerifyStaff
      employersList={employersList}
      employersCount={employersCount}
      loading={loading}
      inviteModalId={ModalId.InviteEmployersAdminsByCVAdmin}
      pagination={pagination}
      onRefresh={refetchData}
    />
  );
};
